import { alpha, lighten } from '@mui/material/styles';
import buttonStyles from '../internals/utils/buttonStyles';
import theme from '../themes/sovos-theme';
const {
  boxShadow
} = buttonStyles;
const {
  palette,
  spacing
} = theme;
export default new Map([['default', {
  contained: {
    backgroundColor: palette.primary.main,
    boxShadow,
    color: palette.primary.contrastText,
    divider: "1px solid ".concat(lighten(palette.primary.main, 0.25)),
    hover: {
      backgroundColor: palette.primary.dark,
      divider: "1px solid ".concat(alpha(palette.primary.contrastText, 0.25))
    }
  },
  outlined: {
    backgroundColor: alpha(palette.primary.contrastText, 0),
    border: "1px solid ".concat(palette.primary.main),
    boxShadow: 'none',
    color: palette.primary.main,
    divider: "1px solid ".concat(alpha(palette.primary.main, 0.25)),
    hover: {
      backgroundColor: alpha(palette.primary.main, 0.08),
      border: "1px solid ".concat(palette.primary.dark, " !important"),
      color: palette.primary.dark,
      divider: "1px solid ".concat(alpha(palette.primary.dark, 0.25), " !important")
    },
    padding: "".concat(spacing(0.625), "px ").concat(spacing(1.875), "px")
  },
  text: {
    backgroundColor: alpha(palette.primary.contrastText, 0),
    boxShadow: 'none',
    color: palette.primary.main,
    divider: "1px solid ".concat(alpha(palette.primary.contrastText, 0)),
    hover: {
      backgroundColor: alpha(palette.primary.main, 0.08),
      divider: "1px solid ".concat(alpha(palette.primary.main, 0))
    }
  }
}], ['disabled', {
  contained: {
    backgroundColor: palette.divider,
    boxShadow,
    color: palette.text.disabled,
    divider: '1px solid #cbd0d6'
  },
  outlined: {
    backgroundColor: alpha(palette.primary.contrastText, 0),
    border: "1px solid ".concat(palette.action.disabled, " !important"),
    boxShadow: 'none',
    color: palette.text.disabled,
    divider: '1px solid #e6e7e9 !important',
    padding: '5px 15px'
  },
  text: {
    backgroundColor: alpha(palette.primary.contrastText, 0),
    boxShadow: 'none',
    color: palette.text.disabled,
    divider: "1px solid ".concat(alpha(palette.primary.contrastText, 0))
  }
}]]);